import 'angular-loading-overlay';

// Exports overlay module which allows injecting bsLoadingOverlayService.
export default 'bsLoadingOverlay';



// WEBPACK FOOTER //
// ./src/common/wrappers/angular-loading-overlay.js